import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer, Copy } from "lucide-react";
import { copyText, SITE } from "./fb/shared";

export const SHORTS = [
  { key: "quote", label: "Free quote", color: "#b45309" },
  { key: "wa", label: "WhatsApp us", color: "#128C4A" },
  { key: "text", label: "Text us", color: "#2563eb" },
  { key: "call", label: "Call us", color: "#0f2e2a" },
  { key: "chat", label: "Live chat", color: "#0e8c7f" },
];
export const url = (k) => `${SITE}/${k}`;
export const canvasOf = (k) => document.querySelector(`[data-qr="${k}"] canvas`);

const download = (k) => {
  const a = document.createElement("a");
  a.href = canvasOf(k).toDataURL("image/png");
  a.download = `stripwise-qr-${k}.png`;
  a.click();
};

const printSheet = () => {
  const cells = SHORTS.map((s) => `<div class="c"><img src="${canvasOf(s.key).toDataURL("image/png")}"/><h2 style="color:${s.color}">${s.label}</h2><p>${url(s.key).replace("https://", "")}</p></div>`).join("");
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>StripWise QR codes</title><style>body{font-family:Arial,sans-serif;margin:24px;text-align:center}.g{display:grid;grid-template-columns:1fr 1fr;gap:28px}.c{border:2px dashed #cfe3df;border-radius:16px;padding:18px}img{width:220px;height:220px}h2{margin:10px 0 4px;font-size:24px}p{margin:0;font-size:18px;font-weight:bold;color:#0f2e2a}</style></head><body><img src="/logo.png" style="height:48px;width:auto"/><h1 style="font-size:22px;color:#0f2e2a">Scan to reach StripWise</h1><div class="g">${cells}</div></body></html>`);
  w.document.close();
  w.onload = () => w.print();
};

const Card = ({ s }) => (
  <div className="flex flex-col items-center rounded-2xl border border-[#e3ecea] bg-white p-2.5 md:p-4" data-testid={`qr-card-${s.key}`}>
    <div data-qr={s.key} className="w-full flex justify-center">
      <QRCodeCanvas value={url(s.key)} size={512} level="H" fgColor={s.color} marginSize={2} style={{ width: "100%", maxWidth: 160, height: "auto" }}
        imageSettings={{ src: "/logo-icon.png", height: 110, width: 110, excavate: true }} />
    </div>
    <div className="mt-2 text-[15px] font-bold" style={{ color: s.color }}>{s.label}</div>
    <code className="text-center text-[10.5px] md:text-[12px] [overflow-wrap:anywhere] text-[#0f2e2a]" data-testid={`short-link-${s.key}`}>stripwisepays.com<wbr />/{s.key}</code>
    <div className="mt-3 flex gap-2">
      <button onClick={() => copyText(url(s.key), "Short link copied")} className="inline-flex items-center gap-1 rounded-full border border-[#cfe3df] px-3 py-1.5 text-[12px] font-bold text-[#0e8c7f]" data-testid={`short-link-${s.key}-copy`}><Copy size={13} />Copy</button>
      <button onClick={() => download(s.key)} className="inline-flex items-center gap-1 rounded-full bg-[#0e8c7f] px-3 py-1.5 text-[12px] font-bold text-white hover:bg-[#0b6f65]" data-testid={`qr-${s.key}-download`}><Download size={13} />PNG</button>
    </div>
  </div>
);

export const QrSection = () => (
  <div className="rounded-2xl border border-[#e3ecea] bg-[#f6fbfa] p-4 md:p-5" data-testid="qr-section">
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <div className="flex-1">
        <h3 className="text-[17px] font-bold text-[#0f2e2a]">Short links & QR codes</h3>
        <p className="text-[12px] text-[#6b7c79]">Easy to say out loud and print on flyers and boxes. Every scan or tap counts in your contact stats.</p>
      </div>
      <button onClick={printSheet} className="inline-flex items-center gap-1.5 rounded-full bg-[#0f2e2a] px-4 py-2 text-[13px] font-bold text-white" data-testid="qr-print-sheet"><Printer size={14} />Print sheet of all</button>
    </div>
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5">{SHORTS.map((s) => <Card key={s.key} s={s} />)}</div>
  </div>
);
